var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFavourites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2748 15.7457L17.453 16.7358L17.4535 16.7389L18.2392 21.3259L14.11 19.1601L14.0824 19.1456L14.0537 19.1335L13.0902 18.7262L12.7629 18.5879L12.4486 18.7535L11.5299 19.2376L11.5248 19.2402L7.38187 21.3831L8.13399 16.7726L8.31169 15.7854L8.37948 15.4088L8.11431 15.1328L7.37928 14.368L7.37205 14.3605L7.36461 14.3532L4.05201 11.093L8.67407 10.4252L8.67408 10.4252L8.67808 10.4246L9.67136 10.2757L10.0721 10.2155L10.2415 9.84738L10.6925 8.86689L12.7903 4.72364L14.8627 8.9134L15.3152 9.89704L15.4845 10.2652L15.8853 10.3253L16.8786 10.4743L16.8786 10.4743L16.8826 10.4749L21.5023 11.1424L18.2347 14.3503L18.2324 14.3525L17.4898 15.0754L17.2041 15.3534L17.2748 15.7457Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFavourites);
export default __webpack_public_path__ + "static/media/icon-favourites.6d7f7f6ff28e9c83316fbee25c580307.svg";
export { ForwardRef as ReactComponent };